"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFuturePayment = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
function isFuturePayment({ effectiveDate, paymentMethod }) {
    // Any Policy sold after midnight east coast will bill immediately
    const parsedEffectiveDate = dayjs_1.default.tz(effectiveDate, 'America/New_York').toDate();
    return parsedEffectiveDate > new Date() && ['C', 'E'].includes(paymentMethod);
}
exports.isFuturePayment = isFuturePayment;
//# sourceMappingURL=payments.js.map